import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

export default new Vuex.Store({
    state : {
        activeNav : null,
        activeValidationEntry : null,
        allActiveValidationEntries: [],
        allFormsData : [],
        xOreAuth : null,
        userProfile : null,
        reportingGroups : [],
        overallBreakdown: [],
        groupStatusBreakdown: []
    },
    getters : {
        activeNav : state => state.activeNav,
        activeValidationEntry : state => state.activeValidationEntry,
        allActiveValidationEntries :  state => state.allActiveValidationEntries,
        allFormsData : state => state.allFormsData,
        userProfile : state => state.userProfile,
        xOreAuth : state => state.xOreAuth,
        reportingGroups : state => state.reportingGroups,
        overallBreakdown : state => state.overallBreakdown,
        groupStatusBreakdown : state => state.groupStatusBreakdown
    },
    mutations : {
        udpateAuthToken(state,token) {
            state.xOreAuth = token;
        },
        updateAllFormsData(state,forms) {
            state.allFormsData = forms;
        },
        updateFormData(state,form) {
            /** 
             * dateLastUpdated 
             * datePublished
             * isActive
             * isActiveStr
             * isPublished
             * lastUpdatedBy
             * lastUpdatedByName
             * publishedByName
             * */ 
            state.allFormsData.forEach(f=>{
                if (f.formId==form.formId) {
                    f.dateLastUpdated = form.dateLastUpdated
                    f.datePublished = form.datePublished
                    f.isActive = form.isActive
                    f.isActiveStr = form.isActiveStr
                    f.isPublished = form.isPublished 
                    f.lastUpdatedBy = form.lastUpdatedBy
                    f.lastUpdatedByName = form.lastUpdatedByName
                    f.publishedByName = form.publishedByName 
                }
            })
        },
        updateActiveNav(state,nav) {
            state.activeNav = nav;
        },
        updateActiveValidationEntry(state,validationEntry) {
            state.activeValidationEntry = validationEntry;
        },
        updateValidationEntries(state,entries) {
            state.allActiveValidationEntries = entries;
        },
        updateUserProfile(state,profile) {
            state.userProfile = profile;
        },
        updateReportingGroups(state,repGroups) {
            state.reportingGroups = repGroups;
        },
        updateOverallBreakdown(state, data){
            state.overallBreakdown = data
        },
        updateGroupStatusBreakdown(state, data) {
            state.groupStatusBreakdown = data
        },
        clearAppData(state){
            state.activeNav = null;
            state.xOreAuth = null;
            state.userProfile = null;
            state.allFormsData = []
            state.overallBreakdown = []
            state.groupStatusBreakdown = []
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js